import classNames from './ClassesWithoutStudents.module.scss';
import mineClassNames from '../DeleteTeacherModal.module.scss';
import { Trans } from 'react-i18next';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import TheButton from '@/components/school-management/TheButton/TheButton';
import { DeletedTeacherGroupData } from '@/school-management/types/response/teacher';

interface ClassesWithoutStudentsProps {
  groups: DeletedTeacherGroupData[];
  onConfirm: () => void;
  onCancel: () => void;
}

const ClassesWithoutStudents = ({ groups, onConfirm, onCancel }: ClassesWithoutStudentsProps) => {
  const { t } = useAdminTranslation();

  return (
    <div className={classNames.content}>
      <h2>{t('schoolDetailsPage.classes.deleteTeacherModal.classesWithoutStudents.title')}</h2>
      <span className={classNames.classes}>
        {groups.map((g, index) => (
          <div key={`group--${index}`}>
            {g.classCode ? (
              <Trans
                ns='admin'
                i18nKey='schoolDetailsPage.classes.deleteTeacherModal.classesWithoutStudents.lineWithClassCode'
                values={{ name: g.groupName, classCode: g.classCode }}
                components={{ strong: <strong /> }}
              />
            ) : (
              <Trans
                ns='admin'
                i18nKey='schoolDetailsPage.classes.deleteTeacherModal.classesWithoutStudents.line'
                values={{ name: g.groupName }}
                components={{ strong: <strong /> }}
              />
            )}
          </div>
        ))}
      </span>
      <div className={mineClassNames.buttonsContainer}>
        <TheButton
          className={mineClassNames.okBtn}
          text={t('schoolDetailsPage.classes.deleteTeacherModal.ok')}
          shouldRecolor={false}
          emitOnClick={onConfirm}
        />
        <TheButton
          className={mineClassNames.cancelBtn}
          text={t('schoolDetailsPage.classes.deleteTeacherModal.cancel')}
          plain
          shouldRecolor={false}
          emitOnClick={onCancel}
        />
      </div>
    </div>
  );
};

export default ClassesWithoutStudents;
